export default __webpack_public_path__ + "static/media/salesforce-light.cc9835a6.svg";